<span #container class="flex items-center" [style.gap]="$gap() | cssValue">

  @if ($icon() !== null) {
  <app-icon [icon]="$icon()!" [color]="$iconColor()" [size]="$iconSize()" [scale]="$iconScale()"
    [rotation]="$iconRotation()" [rotationDelay]="$iconRotationDelay()" [viewBoxAdjustmentX]="$iconViewBoxAdjustmentX()"
    [viewBoxAdjustmentY]="$iconViewBoxAdjustmentY()" />
  }

</span>
